import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService, DialogService, LanguageService } from 'src/app/services';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { from, of } from 'rxjs';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION, COGNITO_ERROR_CODE_MISMATCH_EXCEPTION, COGNITO_ERROR_EXPIRED_CODE_EXCEPTION, COGNITO_ERROR_INVALID_PARAMETER_EXCEPTION } from 'src/app/utils/constant';
import { PasswordValidator } from 'src/app/utils/validators/password-validator';
import { LoginService } from '../login/login.service';
import { switchMap, catchError } from 'rxjs/operators';
import { NoWhiteSpaceValidator } from '../../utils/validators/nowhitespace.validator';
import { EmailValidator } from 'src/app/utils/validators/email.validator';

@Component({
  selector: 'esc-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  show: any = {
    confirm: false,
    password: false
  }
  resetPasswordForm : FormGroup;
  isResendingCode: boolean;
  isSubmitting : boolean;
  errorMessage : string;
  public imgUrl;
  public isGoldwinWarehouse: Boolean = false;

  constructor(
    private fb: FormBuilder, 
    public authService: AuthService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private route: ActivatedRoute, 
    private router: Router,
    private loginService: LoginService
  ){ }

  ngOnInit() {
    this.resetPasswordForm = this.fb.group({
      email: [null, [Validators.required, NoWhiteSpaceValidator, EmailValidator]],
      code: [null, [Validators.required, NoWhiteSpaceValidator]],
      password: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(60), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?\-\"!@#%&/\\,><':;|_~`])[A-Za-z\d\^$*.\[\]{}()?\-\"!@#%&/\\,><':;|_~`]{0,}/)]],
      confirmPassword: [null, Validators.required]
    }, {
      validator: PasswordValidator.matchPassword
    });
    this.route.queryParams.subscribe(params => {
      if(params['email']){
        this.resetPasswordForm.controls['email'].setValue(_.toLower(params['email']));
      }
      if(params['code']){
        this.resetPasswordForm.controls['code'].setValue(_.toLower(params['code']));
      }
    });

    this.isGoldwinWarehouse = (_.includes(window.location.hostname,'goldwin') ? true : false)

    this.imgUrl = (this.isGoldwinWarehouse ? 'assets/images/goldwin-logo.png' : 'assets/images/boc-logo.png');
  }

  resendVerificationCode(value){
    this.isResendingCode = true;
    this.errorMessage = null;
    let email = _.toLower(_.trim(value['email']));

    let cognitoUser = new CognitoUser({
      Username: email,
      Pool: this.authService.userPool
    });

    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        this.isResendingCode = false;
        this.resetPasswordForm.controls['code'].reset();
        this.dialogService.openSnackBar("Verification Code has been resent. Please check your email.")
        this.router.navigate([], { 
          queryParams: {
            email: email
          } 
        });
      },
      onFailure: (err) => {
        this.isResendingCode = false;
        // console.log(err);
        if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
          return this.resetPasswordForm.controls['email'].setErrors({
            "notExisting": true
          });
        } else if (err.name === COGNITO_ERROR_INVALID_PARAMETER_EXCEPTION){
          this.errorMessage = this.languageService.getTranslation("INVALID_USERNAME", null);
          return;
        }
        this.errorMessage = err.message;
      }
    });
  }

  onSubmit(value: any){
    this.errorMessage = null;
    this.isSubmitting = true;
    let email = _.toLower(_.trim(value['email']));
    let newPassword = _.trim(value['password']);
    let code = _.trim(value['code']);

    let cognitoUser = new CognitoUser({
      Username: email,
      Pool: this.authService.userPool
    });



    cognitoUser.confirmPassword(code, newPassword,{
      onSuccess: () => {
        this.isSubmitting = false;
        this.dialogService.openSnackBar("You may now login with your new password")
          .afterOpened()
          .subscribe(() => {
            this.loginService.updateLastChangePasswordDate({ email: email }).pipe(
              catchError((err) => {
                console.error(err);
                return of(null);
              })
            ).subscribe((res) => {
              // console.log(res);
            });;
            this.router.navigate(["/login"], { 
              queryParams: {
                email: email
              } 
            });
        })
      },
      onFailure: (err) => {
        this.isSubmitting = false;
        // console.log(err);
        if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
          this.resetPasswordForm.controls['email'].setErrors({
            "notExisting": true
          });
        } else if(err.name === COGNITO_ERROR_CODE_MISMATCH_EXCEPTION || err.name === COGNITO_ERROR_EXPIRED_CODE_EXCEPTION){
          this.resetPasswordForm.controls['code'].setErrors({
            "codeMismatch": true
          });
          this.router.navigate([], { 
            queryParams: {
              email: email
            } 
          });
        } else if (err.name == COGNITO_ERROR_INVALID_PARAMETER_EXCEPTION){
          this.errorMessage = this.languageService.getTranslation("INVALID_USERNAME_OR_VERIFICATION_CODE", null)
        }else {
          this.errorMessage = err.message;
        }
      }
    });

    // this.cognitoService.forgotPassword(_.toLower(value['email']), function(err, result){
    //   self.inProgress = false;
    //   if(err){
    //     if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
    //       return self.resetPasswordForm.controls['email'].setErrors({
    //         "notExisting": true
    //       });
    //     }
    //     return self.dialogService.confirm({
    //       title: "Forgot Password Failed", 
    //       message: err.message,
    //       button: "Close",
    //       hasCancel: false
    //     });
    //   }

    //   self.dialogService.confirm({
    //     title: "Verification Code Sent", 
    //     message: "Please check your email for verification code",
    //     button: "Close",
    //     hasCancel: false
    //   }).subscribe(res => {
    //     self.router.navigateByUrl("/reset-password?email=" + value['email']);
    //   });
    // });
  }

}
